import { MoimURL } from "common/helpers/url";

export default function useIsExternalBlockitEditorRoute() {
  return (
    MoimURL.ExternalMoimBlockitEditor.isSameExact(location.pathname) ||
    MoimURL.ExternalMoimBlockitEditorV2.isSameExact(location.pathname)
  );
}
